module.exports = __webpack_public_path__ + "static/media/bose-quietcomfort-35-series-II.02cbd0fd.jpg";